import React from 'react';

const BinIcon = ({ size = 18, stroke = 2 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 6h18" />
    <path d="M8 6V4.8c0-.95.77-1.72 1.72-1.72h4.56c.95 0 1.72.77 1.72 1.72V6" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
    <path d="M5.8 6l1.05 13.05A2 2 0 0 0 8.84 21h6.32a2 2 0 0 0 1.99-1.95L18.2 6" />
  </svg>
);

export default BinIcon;
